import OverridesCssBaseline from './cssBaseline';
import OverridesMuiTabs from './tabs';
import OverridesMuiTab from './tab';
import OverridesMuiButton from './button';
import OverridesMuiIconButton from './iconButton';
import OverridesMuiSelect from './select';
import OverridesMuiOutlinedInput from './outlinedInput';
import OverridesMuiListItem from './listItem';
import OverridesMuiMenu from './menu';
import OverridesMuiMenuItem from './menuItem';
import OverridesMuiCheckbox from './checkbox';
import OverridesMuiRadio from './radio';
import { fontSize } from '../font';
import OverridesMuiFormLabel from './formLabel';
import OverridesMuiFormHelperText from './formHelperText';
import OverridesMuiInputAdornment from './inputAdornment';
import OverridesMuiDivider from './divider';
import OverridesMuiFormControl from './formControl';
import OverridesMuiChip from './chip';
import OverridesMuiPaper from './paper';
import OverridesMuiStepIcon from './stepIcon';
import OverridesMuiStepConnector from './stepConnector';
import OverridesMuiStepper from './stepper';
import OverridesMuiStepLabel from './stepLabel';
import OverridesMuiStep from './step';
import OverridesMuiBottomNavigationAction from './bottomNavigationAction';
import OverridesMuiDrawer from './drawer';
import { OverridesTypography } from './typography';
import OverridesMuiAccordion from './accordion';

const overrides = {
  MuiCssBaseline: { ...OverridesCssBaseline },
  MuiTabs: { ...OverridesMuiTabs },
  MuiTab: { ...OverridesMuiTab },
  MuiButton: { ...OverridesMuiButton },
  MuiIconButton: { ...OverridesMuiIconButton },
  MuiSelect: { ...OverridesMuiSelect },
  MuiOutlinedInput: { ...OverridesMuiOutlinedInput },
  MuiListItem: { ...OverridesMuiListItem },
  MuiMenu: { ...OverridesMuiMenu },
  MuiMenuItem: { ...OverridesMuiMenuItem },
  MuiDialog: {
    paper: {
      '@media (max-width: 600px)': {
        margin: '5px',
      },
    },
  },
  MuiDialogContent: {
    root: {
      padding: '0px 24px 24px',
    },
  },
  MuiCheckbox: { ...OverridesMuiCheckbox },
  MuiRadio: { ...OverridesMuiRadio },
  MuiTablePagination: {
    toolbar: {
      '@media (max-width: 480px)': {
        padding: 0,
      },
    },
    selectRoot: {
      '@media (max-width: 480px)': {
        marginRight: '16px',
      },
    },
  },
  MuiSvgIcon: {
    root: {
      fontSize: fontSize._24,
    },

    fontSizeSmall: {
      fontSize: fontSize._16,
    },

    fontSizeLarge: {
      fontSize: fontSize._32,
    },
  },
  MuiFormLabel: { ...OverridesMuiFormLabel },
  MuiFormHelperText: { ...OverridesMuiFormHelperText },
  MuiInputAdornment: { ...OverridesMuiInputAdornment },
  MuiDivider: { ...OverridesMuiDivider },
  MuiFormControl: { ...OverridesMuiFormControl },
  MuiChip: { ...OverridesMuiChip },
  MuiPaper: { ...OverridesMuiPaper },
  MuiStepIcon: { ...OverridesMuiStepIcon },
  MuiStepConnector: { ...OverridesMuiStepConnector },
  MuiStepper: { ...OverridesMuiStepper },
  MuiStepLabel: { ...OverridesMuiStepLabel },
  MuiStep: { ...OverridesMuiStep },
  MuiBottomNavigationAction: { ...OverridesMuiBottomNavigationAction },
  MuiDrawer: { ...OverridesMuiDrawer },
  MuiTypography: { ...OverridesTypography },
  MuiAccordion: { ...OverridesMuiAccordion },
};

export default overrides;
